import { estaActivaPreguntaTipo, obtenerIdsPreguntaTipo, PreguntasTipoEnum } from "@shared/enums";

export class PreguntasTipoEnumExtension {
    public static soloActivos(): PreguntasTipoEnum[] {
        return obtenerIdsPreguntaTipo().map(([genero]) => genero)
            .filter(preguntaTipo => estaActivaPreguntaTipo(preguntaTipo));
    }
}
